<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"background: #FEF8F4;\nbackground: linear-gradient(0deg, rgba(254, 248, 244, 1) 0%, rgba(249, 250, 249, 1) 100%);\npadding: 32px 0px;"' class="container-fluid" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"padding-top:64px;"' class="container-custom mx-auto" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row justify-content-center mx-auto align-items-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 order-2" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="section-right-wrapper" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"font-size: 3rem;\n"' class="title-h2-hero" >
                <template #default>   <m-span v-bind='{...{},...{}}' :style='""' class="text-primary" >
                <template #default>رستوران   </template>
                </m-span><m-span v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>روستای گردشگری پامنار   </template>
                </m-span></template>
                </m-h1><m-p v-bind='{...{},...{}}' :style='""' class="m-4 text-justify" >
                <template #default>رستوران‌های روستای گردشگری پامنار با بهره‌گیری از موقعیت جغرافیایی منحصر‌به‌فرد خود، فضایی ایده‌آل برای استراحت و تغذیه گردشگران فراهم آورده‌اند. این مراکز با ارائه انواع غذاهای محلی و سنتی، از جمله انواع خوراک‌های تهیه شده با مواد اولیه تازه منطقه، میزبان مسافران هستند. فضای باز و نزدیک به دریاچه، این رستوران‌ها را به انتخابی عالی برای خانواده‌ها و گروه‌های گردشگری تبدیل کرده است که به دنبال تجربه‌ای آرام و طبیعی در کنار طبیعت زاگرس هستند.

   </template>
                </m-p><m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-start" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"Home\",\"params\":{}}","target":"_self"},...{}}' :style='"font-size:13px;"' class=" mx-2 text-primary border-primary col-lg-4 col-md-5 mb-2" >
                <template #default>بازگشت به صفحه اصلی   <m-icon v-bind='{...{"icon":""},...{}}' :style='""' class="bi bi-arrow-left-circle-fill mx-1" ></m-icon></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6  order-1 order-lg-2 text-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"position: relative;\ndisplay: inline-block;"' class="mt-4" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.pamenarvillage.ir\/storage\/\u0631\u0633\u062a\u0648\u0631\u0627\u0646-\u06a9\u0627\u0631\u062a\u0627\/photo_2026-05-13_18-07-07.jpg","alt":"clinicyas"},...{}}' :style='"height: 450px;\nwidth:auto;"' class="hero-img-1" ></m-img></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="my-3 text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.pamenarvillage.ir\/storage\/\u0631\u0633\u062a\u0648\u0631\u0627\u0646-\u06a9\u0627\u0631\u062a\u0627\/photo_2026-05-13_18-06-28.jpg","alt":"mix it web"},...{}}' :style='""' class="img-fluid" ></m-img></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="my-3 text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.pamenarvillage.ir\/storage\/assets\/\u06a9\u0627\u0631\u062a\u0627\u0627\u0627\u0627\u0627-1.jpg","alt":"mix it web"},...{}}' :style='""' class="img-fluid col-6" ></m-img></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mSpan from '@moeinmdn/miw-alpha-components/src/package/Tags/Span'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mIcon from '@moeinmdn/miw-alpha-components/src/package/Icons/Icon'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mSpan,mP,mA,mIcon,mImg },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
